import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, HostListener, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-persistent-sidebar',
  templateUrl: './persistent-sidebar.component.html',
  styleUrls: ['./persistent-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PersistentSidebarComponent implements OnInit, OnDestroy, OnChanges {
  @Input() visible: boolean = false;
  @Input() position: 'left' | 'right' = 'right';
  @Input() width: string = '30rem';
  @Input() fullScreen: boolean = false;
  @Input() dismissible: boolean = true;
  @Input() modal: boolean = true;
  @Input() blockScroll: boolean = true;
  @Input() closeOnEscape: boolean = true;
  @Input() showCloseButton: boolean = true;
  @Input() showFullscreenButton: boolean = true;
  @Input() styleClass: string = '';

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() show = new EventEmitter<void>();
  @Output() hide = new EventEmitter<void>();
  @Output() fullScreenChange = new EventEmitter<boolean>();

  private previousBodyOverflow: string = '';

  ngOnInit(): void {
    // Initial state handling
    if (this.visible) {
      this.handleVisibilityChange(true);
    }
  }

  ngOnDestroy(): void {
    // Restore body scroll on destroy
    this.restoreBodyScroll();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']) {
      const isVisible = changes['visible'].currentValue;
      const previousValue = changes['visible'].previousValue;
      // Only handle if value actually changed
      if (isVisible !== previousValue) {
        this.handleVisibilityChange(isVisible);
      }
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    if (this.closeOnEscape && this.visible && this.dismissible) {
      event.preventDefault();
      this.close();
    }
  }

  handleVisibilityChange(isVisible: boolean): void {
    if (isVisible) {
      this.show.emit();
      if (this.blockScroll) {
        this.blockBodyScroll();
      }
    } else {
      this.hide.emit();
      if (this.blockScroll) {
        this.restoreBodyScroll();
      }
    }
  }

  close(): void {
    if (this.dismissible) {
      this.visible = false;
      this.visibleChange.emit(false);
    }
  }

  onBackdropClick(): void {
    if (this.dismissible && this.modal) {
      this.close();
    }
  }

  toggleFullscreen(): void {
    this.fullScreen = !this.fullScreen;
    this.fullScreenChange.emit(this.fullScreen);
  }

  private blockBodyScroll(): void {
    this.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  private restoreBodyScroll(): void {
    document.body.style.overflow = this.previousBodyOverflow;
  }

  getPanelStyle(): { [key: string]: string } {
    const style: { [key: string]: string } = {};
    
    if (this.fullScreen) {
      style['width'] = '100%';
    } else {
      style['width'] = this.width;
    }

    return style;
  }
}

